/**
 * Global cart live announcements: on cart:update, debounced sync for the initiating
 * cart-items-component (drawer, featured menu, main cart, etc.) using the same diff
 * copy as cart-state-logger (via cart-live-announce-shared.js).
 */
import { ThemeEvents } from '@theme/events';
import { queueSyncCartHost, seedAllCartHostsWithLiveRegion } from './cart-live-announce-shared.js';

const LOG = '[znt/cart-live-region]';

function zntLog(...args) {
  console.log(LOG, ...args);
}

function seedHosts() {
  seedAllCartHostsWithLiveRegion();
  zntLog('seeded cart hosts with live region', {
    count: document.querySelectorAll('cart-items-component [data-znt-cart-live-region]').length,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    seedHosts();
    setTimeout(seedHosts, 700);
  });
} else {
  seedHosts();
  setTimeout(seedHosts, 700);
}

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const detail = event.detail;
  const sourceId = detail?.sourceId;

  zntLog('cart:update', {
    sourceId,
    itemCount: detail?.data?.itemCount,
    source: detail?.data?.source,
  });

  if (!sourceId || typeof sourceId !== 'string') return;

  const host = document.querySelector(`cart-items-component[data-section-id="${CSS.escape(sourceId)}"]`);
  if (!host) {
    zntLog('no cart-items-component for sourceId', sourceId);
    return;
  }

  queueSyncCartHost(host);
});

zntLog('listening for', ThemeEvents.cartUpdate);
